import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import Vant from 'vant';
import './css/iconfont.css'
import 'vant/lib/index.css'
import './css/reset.css'
import htmlToPdf from './utils/htmlToPdf'
import store from './store'
import './utils/day'
import 'video.js/dist/video-js.css'
import Video from 'video.js'
Vue.config.productionTip = false
Vue.prototype.$video = Video
Vue.use(Vant)
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(htmlToPdf)
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
